import { render, staticRenderFns } from "./PendingCardItem.vue?vue&type=template&id=4cc6ca4e&scoped=true&lang=pug&"
import script from "./PendingCardItem.vue?vue&type=script&lang=ts&"
export * from "./PendingCardItem.vue?vue&type=script&lang=ts&"
import style0 from "./PendingCardItem.vue?vue&type=style&index=0&id=4cc6ca4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6ca4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
